
import clientAxios from "../client";

import type {
    TranslationPayloadType,
    TranslationType,
} from "@/common/types/translation";

export async function translationList(
    owner_id: string
) {
    return await clientAxios.get(
        `common/translation/${owner_id}/list`
    );
}

export async function translationAdd(
    owner_id: string,
    payload: TranslationPayloadType,
) {
    return await clientAxios.post(
        `common/translation/${owner_id}/create`,
        payload
    );
}

export async function translationPatch(
    translation_id: string,
    payload: Partial<TranslationType>,
) {
    return await clientAxios.patch(
        `common/translation/${translation_id}/patch`,
        { payload }
    );
}

export async function translationDel(
    translation_id: string,
) {
    return await clientAxios.del(
        `common/translation/${translation_id}/delete`
    );
}
